export const formName = ({name, nameUkr, nameEng, ukrName, engName, language} = {}) => {
  const nameInUkr = nameUkr || ukrName || name;
  const nameInEng = nameEng || engName;

  return language === "en" ? nameInEng || nameInUkr || "" : nameInUkr || nameInEng || "";
};
